export const InjectManageCodesService = Symbol.for("CountryCodesService");
export type CountriesTypeSelected = { text: string; country: string; code: string; selected: boolean };
export type GetCountriesType = { countries: { country: string; code: string }[] };

export interface IManageCodesService {
  getSelectedCountries(): Promise<GetCountriesType>;

  saveCodes(selectedCountries: Map<string, CountriesTypeSelected> | undefined): Promise<void>;
}
